module.exports = __webpack_public_path__ + "media/images/icons/icon-call-a3bf00aa2b63dd5e995410367e5744df.svg";